<template>
  <div class="my-3">
    <div class="font-medium font-weight-bold">
      Excerpts
    </div>

    <template>
      <v-chip
        class="mt-2 ml-2 clickable"
        :disabled="(productExcerpt && productExcerpt.id != -1)"
        @click="openDialog()"
      >
        Add Product Excerpts

        <v-avatar right>
          <v-icon>mdi-plus</v-icon>
        </v-avatar>
      </v-chip>
      <div
        v-if="productExcerpt && productExcerpt.id != -1"
        class="mt-6"
      >
        <draggable
          v-model="productExcerptClone"
          :disabled="true"
          :options="{ disabled: isLoading }"
        >
          <transition-group>
            <div
              v-for="m in productExcerptClone"
              :key="m.id"
              class="media"
            >
              <div
                class="handle"
                style="height: 100%; width: 100%"
              >
                <v-icon>mdi-drag-horizontal-variant</v-icon>
              </div>

              <a
                :href="cdnUrl + m.excerptUrl"
                target="_blank"
                :disabled="true"
                class="btn"
              >
                <div>
                  {{ getFilename(m.excerptUrl) }}
                </div>
              </a>

              <button
                class="end"
                :aria-label="'delete excerpt ' + m.id"
                :disabled="m.id === -1"
                @click="isDeleteDialogOpen = true"
              >
                <v-icon>mdi-close</v-icon>
              </button>

              <div class="loading-indicator">
                <base-loader v-if="m.id === -1" />
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </template>

    <BaseLoader v-if="productExcerpt == null" />

    <template v-if="isDialogOpen">
      <v-dialog
        v-model="isDialogOpen"
        persistent
      >
        <v-card>
          <v-form ref="form">
            <v-card-title class="bpg-card-title-block d-flex justify-space-between">
              <div class="font-weight-extra">
                Add Product Excerpt
              </div>
              <v-btn
                icon
                aria-label="close"
                @click="closeDialog()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <div class="pa-6 font-default-size">
              <div class="field">
                <span class="font-medium font-weight-bold">Excerpt</span>
                <div>
                  <small>filenames should be in the following format. <b>ISBN13SKU</b>.pdf or
                    <b>Excerpt_ISBN13SKU</b>.pdf</small>
                </div>
                <div>
                  <span
                    v-if="filenameError != null"
                    class="file-error"
                  >{{ filenameError }}</span>
                </div>
                <FileDrop
                  v-if="!newProductExcerpt || (newProductExcerpt && !newProductExcerpt.linkFile)"
                  :value="newProductExcerpt.linkFile ? newProductExcerpt.linkFile.name : ''"
                  accept="application/pdf"
                  class="mt-6"
                  @input="onLinkFileChange($event)"
                  @clear="newProductExcerpt.linkFile = null"
                >
                  <div>
                    <span class="font-weight-bold primary--text"> Browse</span><span> or drop your pdf file here.</span>
                  </div>
                </FileDrop>
                <div
                  v-else
                  class="d-flex align-center mt-6"
                >
                  <div class="editing-box">
                    {{ newProductExcerpt.linkFile.name }}
                  </div>
                  <v-btn
                    text
                    @click="newProductExcerpt.linkFile = null"
                  >
                    <v-icon class="close-button clickable ml-2">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div class="d-flex justify-space-between stripe px-6 py-3">
              <v-btn
                text
                @click="closeDialog()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!(filenameError == null && newProductExcerpt.linkFile != null)"
                @click="onAdd()"
              >
                Apply
              </v-btn>
            </div>
          </v-form>
        </v-card>
      </v-dialog>
    </template>

    <!--delete confirmation-->
    <template v-if="isDeleteDialogOpen">
      <v-dialog
        v-model="isDeleteDialogOpen"
        persistent
        width="375"
      >
        <v-card>
          <v-card-title class="bpg-card-title-block d-flex justify-space-between">
            <div class="font-weight-extra">
              Delete Product Excerpt
            </div>
          </v-card-title>
          <div class="pa-6 font-default-size">
            <div class="field">
              <div>
                Are you sure you want to delete this product excerpt?
              </div>
            </div>
          </div>
          <div class="d-flex justify-space-between stripe px-6 py-3">
            <v-btn
              text
              @click="closeDeleteDialog()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="deleteProductExcerpt()"
            >
              Apply
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </template>
    <!--end delete confirmation-->
  </div>
</template>

<script>
import BaseLoader from "../../base/base-loader.vue"
import * as cloneDeep from "lodash.clonedeep"
import FileDrop from "../../shared/file-drop.vue"
import draggable from "vuedraggable"

const defaultProductExcerpt = {
  linkFile: null,
  productId: null,
  cdnLink: "",
  sku: "",
  id: -1
}

export default {
  name: "ProductExcerpt",
  components: { BaseLoader, FileDrop, draggable },
  props: ["productExcerpt"],
  data: () => ({
    isDialogOpen: false,
    productId: null,
    cdnUrl: process.env.VUE_APP_CDN_URL,
    productExcerptClone: [],
    isDeleteDialogOpen: false,
    filenameError: null,
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"]
        ]
      }
    },
    newProductExcerpt: cloneDeep(defaultProductExcerpt),
    editingProductExcerpt: null,
    linkType: "url"
  }),
  computed: {
    isLoading () {
      return this.productExcerpt != null
    }
  },
  watch: {
    productExcerpt: {
      handler () {
        this.productExcerptClone = [cloneDeep(this.productExcerpt)]
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    closeDialog () {
      this.isDialogOpen = false
      this.filenameError = null
      this.newProductExcerpt = cloneDeep(defaultProductExcerpt)
      this.editingProductExcerpt = null
    },
    openDialog () {
      this.isDialogOpen = true
    },
    onOpenFileUpload () {
      this.$refs.fileUpload.click()
    },
    onLinkFileChange (fileList) {
      if (fileList && fileList[0] && this.validateFilename(fileList[0].name)) {
        this.newProductExcerpt.linkFile = fileList[0]
        this.newProductExcerpt.sku = this.productExcerpt.sku
      }
    },
    getFilename (url) {
      let filename = ""
      if (url) {
        // extract filename substring from url of excerptUrl in productExcerpt. The filename begins with Excerpt_
        let indexOfFilename = url.indexOf("Excerpt_")
        filename = url.substring(indexOfFilename)
      }

      return filename
    },
    deleteProductExcerpt () {
      this.isDeleteDialogOpen = false
      this.$emit("deleteExcerpt", this.productExcerptClone[0].id)
    },
    onAdd () {
      if (!this.$refs.form.validate()) {
        return
      }

      const clone = cloneDeep(this.newProductExcerpt)

      this.$emit("addProductExcerpt", clone)

      this.closeDialog()
    },
    closeDeleteDialog () {
      this.isDeleteDialogOpen = false
    },
    validateFilename (filename) {
      const regex = /^((Excerpt_|excerpt_)\d{13}|\d{13})\.pdf$/
      if (!regex.test(filename)) {
        this.filenameError = 'Filename must be in the format "Excerpt_XXXXXXXXXXXXX.pdf" or contain only 13 digits and end with ".pdf".'
        return false
      } else {
        this.filenameError = null
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/styles/variables";

.field {
  &:not(:first-of-type) {
    margin-top: 24px;
  }
}

.file-error {
  color: $red;
  font-weight: 600;
  margin-top: 4px;
}

.stripe {
  background-color: $even-lighter-grey;
}

.media {
  border-top: 1px solid $light-grey;
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  background-color: $white;
  position: relative;

  div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .handle {
    display: flex;
    align-items: center;
    cursor: move;
    justify-content: center;

    &:hover {
      background-color: $even-lighter-grey;
    }
  }
}

.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btn {
  text-align: start;
  display: flex;
  gap: 24px;

  &:hover {
    background-color: $even-lighter-grey;
  }

  padding: 24px 0;
}

.end {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: $even-lighter-grey;
  }
}

.stripe {
  background-color: $even-lighter-grey;
}

.editing-box {
  flex: 1;
  border-radius: 4px;
  border: 1px solid $black;
  color: $dark-blue;
  font-weight: 900;
  min-height: 50px;
  padding: 0 24px;
  display: flex;
  align-items: center;
}
</style>
